// src/pages/tournament/GroupsSetting.jsx
// The 'groups-finals' format: how many teams a group has (the number of groups follows from the number of teams),
// how many teams of each go through to the knockout, and whether the losing semifinalists play for third place.
// The group size is locked once the first round is planned (the group games are drawn from it), the other two
// once the knockout has started.
import React, { useEffect, useState } from 'react';

const MAX_TEAMS_PER_GROUP = 32; // keep in sync with Tournament.MAX_TEAMS_PER_GROUP in backend/entities.py
const MAX_ADVANCE = 8; // keep in sync with Tournament.MAX_ADVANCE
const NUMBERS = Array.from({ length: MAX_ADVANCE }, (_, i) => i + 1);

function GroupsSetting({ details = {}, onChange, groupsLocked, knockoutStarted, locked }) {
    const teamsPerGroup = details.teamsPerGroup ?? 4;
    const groupCount = details.groupCount ?? 1;
    const [draft, setDraft] = useState(String(teamsPerGroup));
    useEffect(() => setDraft(String(teamsPerGroup)), [teamsPerGroup]);
    const draftValid = Number.isInteger(Number(draft)) && draft !== '' && Number(draft) >= 2 && Number(draft) <= MAX_TEAMS_PER_GROUP;
    const saveDraft = () => {
        if (!draftValid) setDraft(String(teamsPerGroup));
        else if (Number(draft) !== teamsPerGroup) onChange({ teamsPerGroup: Number(draft) });
    };
    const advancePerGroup = details.advancePerGroup ?? 2;
    const thirdPlace = details.thirdPlace !== false;
    return (
        <section className="card groups-card" aria-label="Groups and finals">
            <h2>Groups &amp; finals</h2>
            <div className="details-grid">
                <label className="field">
                    <span>Teams per group</span>
                    <input
                        className="input"
                        type="number"
                        min="2"
                        max={MAX_TEAMS_PER_GROUP}
                        inputMode="numeric"
                        value={draft}
                        disabled={locked || groupsLocked}
                        onChange={(event) => setDraft(event.target.value)}
                        onBlur={saveDraft}
                        onKeyDown={(event) => event.key === 'Enter' && event.target.blur()}
                    />
                </label>
                <label className="field">
                    <span>Advancing per group</span>
                    <select
                        className="input"
                        value={advancePerGroup}
                        disabled={locked || knockoutStarted}
                        onChange={(event) => onChange({ advancePerGroup: Number(event.target.value) })}
                    >
                        {NUMBERS.map((n) => (
                            <option key={n} value={n}>
                                {n}
                            </option>
                        ))}
                    </select>
                </label>
            </div>
            <label className="check-row">
                <input
                    type="checkbox"
                    checked={thirdPlace}
                    disabled={locked || knockoutStarted}
                    onChange={(event) => onChange({ thirdPlace: event.target.checked })}
                />{' '}
                Play a match for third place
            </label>
            <p className="hint">
                {groupCount} group{groupCount === 1 ? '' : 's'} with the current teams.{' '}
                {groupsLocked
                    ? 'The group size is locked once the first round has been planned. '
                    : 'Teams are dealt over the groups at random; move them on the Players tab. '}
                {knockoutStarted && 'The knockout has started, so the rest is locked too.'}
            </p>
        </section>
    );
}

export default GroupsSetting;
